import orderItemStatusOptions from './order-item-status-options'
import { multiplierField } from '../multiplier'

export default [
  {
    name: 'Product',
    prop: 'product_id',
    type: 'autocomplete',
    references: 'admin/products',
    referenceProp: 'name',
    onChange: (value, resource) => {
      if (value.price) {
        resource.item_price = value.price.toFixed(2)
      }
      if (value.name) {
        resource.item_description = value.name
      }
    }
  },
  {
    name: 'Item Price',
    prop: 'item_price',
    type: 'text'
  },
  {
    name: 'Item Status',
    prop: 'item_status',
    type: 'select',
    options: orderItemStatusOptions,
    showIf: resource => !!resource.id
  },
  {
    name: 'Item Description',
    prop: 'item_description',
    type: 'text'
  },
  multiplierField
]
